/* eslint-disable */
// import axios from 'axios'
// import firebase from 'firebase'

const state = {

}

const getters = {

}

const mutations = {
  // setImages: (state, images) => {
  //   state.images = images
  // }
}

const actions = {
  // async uploadImages ({commit}, images) {

  //   // 1. GET FILES
  //   Array.from(images).map(image => {

  //     const formData = new FormData()
  //           formData.append('image', image, image.name)
            
  //           console.log('Name: ', image.name)
  //           console.log('Size: ', image.size)
  //           console.log('------------------')            

     // 2. CREATE STOREGE REF & UPLOAD FILE
    // var storageRef = firebase.storage().ref('Uploads/' + image.name)
    // storageRef.put(image)
       
    //3. UPLOAD FILE
    // axios.post('gs://mga-animal-forms.appspot.com/Uploads', formData)
    //      .then(response => {
    //            console.log(response)
    //      }).catch(error => {
    //            console.log(error)
    //    })
    // })
    //return Promise.all(promises)

    // 4. UPDATE PROGRESS BAR    
  // }
}



export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/images.js